import styles from './styles.module.scss';

import { DragItems, DropItems } from '../../types';
import { DropBox } from '../DropBox';
import { PortugolCode } from '../TextHighlighter';

export interface PseudocodeProps extends React.HTMLAttributes<HTMLDivElement> {
    code: string[][];
    dropAreas?: DropItems[];
    validateOnDrop?: any;
    currentEx: number;
}

export const Pseudocode = ({
    code,
    dropAreas,
    validateOnDrop,
    currentEx,
    ...rest
}: PseudocodeProps) => {
    const renderDropBox = ({ id, name }: DropItems) => {
        const key = parseInt(currentEx.toString() + id.toString());

        return (
            <DropBox
                key={key}
                className={styles.dropBox}
                items={{ id, name } as DropItems}
                onDrop={validateOnDrop}
            />
        );
    };

    const renderLineElement = (element: any) => {
        if (element.name === 'text') {
            if (element.value === 'tab') {
                return (
                    String.fromCharCode(8195) +
                    String.fromCharCode(8195) +
                    String.fromCharCode(8195)
                );
            }
            return <PortugolCode code={element.value} />;
        } else {
            return renderDropBox(element);
        }
    };

    const renderLine = (line: string[]) => {
        let lineElements: any[] = [];
        let isDropArea: boolean;

        line.forEach(text => {
            isDropArea = false;

            dropAreas?.forEach(dropArea => {
                if (text === dropArea.name) {
                    lineElements.push(dropArea);
                    isDropArea = true;
                }
            });

            if (!isDropArea) {
                const textElement = {
                    name: 'text',
                    value: text
                };

                lineElements.push(textElement);
            }
        });

        return <div className={styles.codeLine}>{lineElements.map(renderLineElement)}</div>;
    };

    return (
        <div className={styles.container} {...rest}>
            {code.map(renderLine)}
        </div>
    );
};
